<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="dueDate">Due Date</label>
                    <wj-input-date id="dueDate" [(ngModel)]="target.dueDate" name="dueDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>

            <div class="col-6">
                <div class="form-group">
                    <label for="doneDate">Done Date</label>
                    <wj-input-date id="doneDate" [(ngModel)]="target.doneDate" name="doneDate" [isRequired]="false"></wj-input-date>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="name">Milestone Name</label>
                    <input id="name" type="text" class="form-control" [(ngModel)]="target.name" name="name" />
                </div>
            </div>
        </div>

        @if (isAdding) {
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="userId">Who</label>
                        <fa-icon
                            [icon]="faQuestionCircle"
                            style="margin-left: 5px; cursor: pointer"
                            title="When adding a new Milestone, multiple users can be selected, and a new Milestone will be created for each user"
                        ></fa-icon>
                        <wj-multi-select
                            id="userId"
                            name="userId"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                            [placeholder]="'Select User(s)'"
                            [headerFormat]="'{count:n0} users'"
                            [itemsSource]="userList"
                        >
                        </wj-multi-select>
                    </div>
                </div>
            </div>
        } @else {
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label for="userId">Who</label>
                        <wj-combo-box
                            id="userId"
                            [(ngModel)]="target.userId"
                            name="userId"
                            [itemsSource]="userList"
                            [displayMemberPath]="'display'"
                            [selectedValuePath]="'value'"
                        ></wj-combo-box>
                    </div>
                </div>
            </div>
        }
    </div>

    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
